import React from 'react';

import EstotusListComponent from '../../components/Estatos/estatos_list_component';
import NavBar from '../../components/common/navbar';
import SideBar from '../../components/modules/left_sidebar';
import NotificacoesGrid from './NotificacoesGrid';

const Administration = false;

class NotificacoesPage extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <div className="dashboard">
        <NavBar
          topBarMenuOption={topBarMenu}
          moduleName="Administration"
        />
        <SideBar Administration={Administration} />
        <div className="container-fluid">
          <NotificacoesGrid topBarMenuOption={topBarMenu} />
        </div>
      </div>
    );
  }
}

export default NotificacoesPage;
